/* Niets — global cart helpers (AJAX add + drawer + reward tier progress).
 *
 * The Aperiniets reward UX (CTA + line markdown + 5%-off summary line + total
 * adjustments) has been removed. A Shopify discount app handles the reward
 * server-side now. This script is responsible for:
 *   - Tier progress bars (free shipping / free Aperiniets / 5% off)
 *   - AJAX add-to-cart (so customers stay on the page)
 *   - Drawer open/close + line qty handling
 *   - Cart count badge sync
 */
(function () {
  'use strict';

  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function $(s, r) { return (r || document).querySelector(s); }
  function isCartPage() {
    return /(^|\/)cart\/?$/.test(window.location.pathname);
  }
  function t(key, vars) {
    var drawer = $('[data-niets-cart-drawer]');
    if (!drawer) return key;
    var val = drawer.getAttribute('data-i18n-' + key) || key;
    if (vars) {
      Object.keys(vars).forEach(function (k) {
        val = val.replace(new RegExp('\\{\\{\\s*' + k + '\\s*\\}\\}', 'g'), vars[k]);
      });
    }
    return val;
  }

  /* --------------------------------------------------------------- toast */
  function showToast(message) {
    var toast = document.getElementById('niets-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'niets-toast';
      toast.setAttribute('role', 'status');
      toast.style.cssText = [
        'position:fixed', 'right:24px', 'bottom:24px', 'z-index:99999',
        'background:#0d0d0b', 'color:#f5f2ec',
        'padding:14px 22px', 'border-radius:999px',
        'font-family:Inter,system-ui,sans-serif', 'font-size:13px', 'letter-spacing:0.04em',
        'box-shadow:0 10px 40px rgba(0,0,0,0.25)',
        'opacity:0', 'transform:translateY(8px)',
        'transition:opacity 200ms ease, transform 200ms ease',
        'pointer-events:none'
      ].join(';');
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    requestAnimationFrame(function () {
      toast.style.opacity = '1';
      toast.style.transform = 'translateY(0)';
    });
    clearTimeout(toast._hide);
    toast._hide = setTimeout(function () {
      toast.style.opacity = '0';
      toast.style.transform = 'translateY(8px)';
    }, 1800);
  }

  /* ----------------------------------------------------------- formatters */
  function formatMoney(cents) {
    var drawer = $('[data-niets-cart-drawer]');
    var currency = (drawer && drawer.dataset.currency) || 'EUR';
    var docLang = (document.documentElement.getAttribute('lang') || 'en').toLowerCase().slice(0, 2);
    var localeMap = { fr: 'fr-BE', nl: 'nl-BE', en: 'en-IE', de: 'de-DE', it: 'it-IT', es: 'es-ES' };
    var locale = localeMap[docLang] || 'fr-BE';
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' ' + currency;
    }
  }
  function formatThreshold(amount) {
    return formatMoney(amount * 100);
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ------------------------------------------------------------- drawer */
  function getDrawer()  { return $('aside[data-niets-cart-drawer]'); }
  function getOverlay() { return $('[data-niets-cart-overlay]'); }

  function openDrawer() {
    var d = getDrawer(), o = getOverlay();
    if (!d) return;
    d.setAttribute('aria-hidden', 'false');
    if (o) o.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    refreshAndRender();
  }
  function closeDrawer() {
    var d = getDrawer(), o = getOverlay();
    if (!d) return;
    d.setAttribute('aria-hidden', 'true');
    if (o) o.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  /* ------------------------------------------------------ tier progress */
  function renderTiers(cart) {
    var containers = $$('[data-niets-cart-drawer]');
    containers.forEach(function (container) {
      var box = $('[data-niets-cart-tiers]', container);
      if (!box) return;

      var tiers = [];
      [0, 1, 2].forEach(function (i) {
        var threshold = parseFloat(container.getAttribute('data-tier-' + i + '-threshold'));
        var label = container.getAttribute('data-tier-' + i + '-label');
        if (threshold > 0 && label) tiers.push({ threshold: threshold, label: label, idx: i });
      });
      tiers.sort(function (a, b) { return a.threshold - b.threshold; });

      if (!tiers.length) { box.innerHTML = ''; box.style.display = 'none'; return; }
      box.style.display = '';

      var totalEUR = (cart.total_price || 0) / 100;
      var html = tiers.map(function (tDef) {
        var pct = Math.min(100, Math.max(0, (totalEUR / tDef.threshold) * 100));
        var met = totalEUR >= tDef.threshold;
        var status = met ? t('unlocked') : t('to-unlock', { amount: formatThreshold(tDef.threshold - totalEUR) });
        return [
          '<div class="ncd-tier">',
            '<div class="ncd-tier-row">',
              '<span class="ncd-tier-label">' + escapeHtml(tDef.label) + '</span>',
              '<span class="ncd-tier-status' + (met ? ' is-met' : '') + '">' + escapeHtml(status) + '</span>',
            '</div>',
            '<div class="ncd-tier-bar"><div class="ncd-tier-fill' + (met ? ' is-met' : '') + '" style="width:' + pct + '%"></div></div>',
          '</div>'
        ].join('');
      }).join('');
      box.innerHTML = html;
    });
  }

  /* ------------------------------------------------------ items render */
  function renderItems(cart) {
    var drawer = getDrawer();
    if (!drawer) return;
    var box = $('[data-niets-cart-items]', drawer);
    var subtotal = $('[data-niets-cart-subtotal]', drawer);
    var checkout = $('[data-niets-cart-checkout]', drawer);
    if (!box) return;

    if (!cart.items || cart.items.length === 0) {
      box.innerHTML = '<div class="ncd-empty">' + escapeHtml(t('empty')) + '</div>';
      if (subtotal) subtotal.textContent = formatMoney(0);
      if (checkout) checkout.setAttribute('aria-disabled', 'true');
      return;
    }
    if (checkout) checkout.removeAttribute('aria-disabled');

    var html = cart.items.map(function (item) {
      var img = item.image
        ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.product_title || item.title) + '" class="ncd-item-img" loading="lazy">'
        : '<div class="ncd-item-img"></div>';
      var variant = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<div class="ncd-item-variant">' + escapeHtml(item.variant_title) + '</div>'
        : '';
      var name = '<a href="' + escapeHtml(item.url) + '" class="ncd-item-name">' + escapeHtml(item.product_title || item.title) + '</a>';
      var priceHtml = '<div class="ncd-item-price">' + formatMoney(item.final_line_price) + '</div>';
      return [
        '<div class="ncd-item" data-line="' + (item.key) + '">',
          img,
          '<div class="ncd-item-text">',
            name,
            variant,
            '<div class="ncd-qty-row">',
              '<button class="ncd-qty-btn" data-niets-qty-change="-1" aria-label="' + escapeHtml(t('decrease')) + '">−</button>',
              '<span class="ncd-qty-val">' + item.quantity + '</span>',
              '<button class="ncd-qty-btn" data-niets-qty-change="1" aria-label="' + escapeHtml(t('increase')) + '">+</button>',
              '<button class="ncd-item-remove" data-niets-qty-set="0">' + escapeHtml(t('remove')) + '</button>',
            '</div>',
          '</div>',
          priceHtml,
        '</div>'
      ].join('');
    }).join('');
    box.innerHTML = html;

    if (subtotal) subtotal.textContent = formatMoney(cart.total_price || 0);
  }

  function bindLineHandlers() {
    var drawer = getDrawer();
    if (!drawer || drawer._lineBound) return;
    drawer._lineBound = true;

    drawer.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-niets-qty-change], [data-niets-qty-set]');
      if (!btn) return;
      var item = btn.closest('[data-line]');
      if (!item) return;
      var key = item.getAttribute('data-line');
      var current = cartCache && cartCache.items ? (cartCache.items.find(function (i) { return i.key === key; }) || {}).quantity : 0;
      current = current || 0;
      var newQty;
      if (btn.hasAttribute('data-niets-qty-set')) {
        newQty = parseInt(btn.getAttribute('data-niets-qty-set'), 10);
      } else {
        var delta = parseInt(btn.getAttribute('data-niets-qty-change'), 10) || 0;
        newQty = current + delta;
      }
      if (newQty < 0) newQty = 0;
      btn.disabled = true;
      changeLine(key, newQty).then(function () { btn.disabled = false; });
    });
  }

  /* --------------------------------------------------------- cart state */
  var cartCache = null;
  function updateCount(cart) {
    cartCache = cart;
    $$('[data-niets-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count > 0 ? (' · ' + cart.item_count) : '';
    });
  }
  function refreshCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCount(cart);
        return cart;
      })
      .catch(function () { return null; });
  }
  function refreshAndRender() {
    return refreshCart().then(function (cart) {
      if (!cart) return;
      renderTiers(cart);
      renderItems(cart);
      bindLineHandlers();
      render5PercentLine(cart);
    });
  }

  /* Cart-page subtotal + 5% off line.
     - Subtotal: sum of line items at original price, excluding free lines (€139.80 in user's example).
       That way subtotal − 5% off = total reads naturally.
     - 5% off: read Shopify's actual reported discount (cart.original_total_price - cart.total_price).
     - Total cell: untouched (Shopify's value). */
  function render5PercentLine(cart) {
    var subRow = $('[data-niets-cart-subtotal-row]');
    if (!subRow) return;
    var drawer = $('[data-niets-cart-drawer]');
    if (!drawer) return;
    var tier2 = parseFloat(drawer.getAttribute('data-tier-2-threshold') || '0');
    var actualTotal = cart.total_price || 0;
    var origTotal = cart.original_total_price || actualTotal;
    var savedCents = Math.max(0, origTotal - actualTotal);

    /* Compute display subtotal = sum of original line prices excluding free lines */
    var displaySubCents = 0;
    if (cart.items) {
      cart.items.forEach(function (it) {
        if ((it.final_line_price || 0) === 0) return; /* free line: contributes 0 */
        displaySubCents += (it.original_line_price || it.final_line_price || 0);
      });
    }
    var subValSpan = $('[data-niets-cart-subtotal-value]');
    if (subValSpan && displaySubCents > 0) {
      subValSpan.textContent = formatMoney(displaySubCents);
    }

    var existing = $('[data-niets-cart-tier2-row]');
    if (savedCents > 0 && tier2 > 0 && (actualTotal / 100) >= tier2) {
      var html = '<div class="ncp-summary-row" data-niets-cart-tier2-row style="color:var(--niets-moss);"><span>5% off (€' + tier2 + '+ orders)</span><span>−' + formatMoney(savedCents) + '</span></div>';
      if (existing) {
        existing.outerHTML = html;
      } else {
        subRow.insertAdjacentHTML('afterend', html);
      }
    } else if (existing) {
      existing.remove();
    }
  }
  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCount(cart);
        renderTiers(cart);
        renderItems(cart);
        return cart;
      });
  }

  /* ----------------------------------------------------------- AJAX add */
  function ajaxAdd(form, button) {
    var fd = new FormData(form);
    if (!fd.has('id')) return Promise.reject(new Error('No variant id'));
    var prevText = button ? button.textContent : null;
    if (button) {
      button.disabled = true;
      button.dataset.prevText = prevText || '';
      button.textContent = t('adding');
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: fd
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      })
      .then(function () {
        return refreshAndRender().then(function () {
          if (button) {
            button.textContent = t('added-check');
            setTimeout(function () {
              button.disabled = false;
              button.textContent = button.dataset.prevText || 'Add';
            }, 1400);
          }
          if (isCartPage()) {
            window.location.reload();
          } else {
            openDrawer();
          }
        });
      })
      .catch(function (err) {
        var msg = (err && err.description) ? err.description : t('could-not-add');
        showToast(msg);
        if (button) {
          button.disabled = false;
          button.textContent = button.dataset.prevText || 'Add';
        }
      });
  }

  /* -------------------------------------------------------- delegation */

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = (form.getAttribute('action') || '').toLowerCase();
    if (action.indexOf('/cart/add') === -1) return;
    if (form.matches('product-form form, [data-niets-pdp-form]')) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"], button:not([type])');
    ajaxAdd(form, btn);
  }, true);

  document.addEventListener('click', function (e) {
    var trig = e.target.closest('[data-niets-cart-trigger], a.niets-cart-pill, a[href="/cart"], a[href$="/cart"]');
    if (!trig) return;
    if (trig.matches('.ncd-view-cart')) return;
    if (isCartPage()) { e.preventDefault(); return; }
    e.preventDefault();
    openDrawer();
  });

  document.addEventListener('click', function (e) {
    if (e.target.matches('[data-niets-cart-close]') || e.target.closest('[data-niets-cart-close]')) {
      closeDrawer();
    } else if (e.target.matches('[data-niets-cart-overlay]')) {
      closeDrawer();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var d = getDrawer();
      if (d && d.getAttribute('aria-hidden') === 'false') closeDrawer();
    }
  });

  /* ------------------------------------------------------ initialise */
  function init() { refreshAndRender(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.NietsCart = {
    add: function (variantId, quantity) {
      var form = document.createElement('form');
      var i = document.createElement('input'); i.name = 'id'; i.value = String(variantId);
      var q = document.createElement('input'); q.name = 'quantity'; q.value = String(quantity || 1);
      form.appendChild(i); form.appendChild(q);
      return ajaxAdd(form, null);
    },
    open: openDrawer,
    close: closeDrawer,
    refresh: refreshAndRender
  };
})();
